/*
 * Reading the backend's refusal to add a duplicate contact. The comparison rule
 * itself lives on the server and is reached through the contactDuplicates
 * query — the client deliberately keeps no copy of it, so the form and the
 * mutation can never disagree about what counts as a duplicate.
 */
import { ContactDuplicateField } from '../types';
import { readErrorExtensionList } from './graphql-error.helpers';

// The credentials the mutation rejected, as its error names them. Empty for
// any other failure, which the caller surfaces as a general error instead.
export const readDuplicateFields = (error: unknown): ContactDuplicateField[] =>
  readErrorExtensionList<ContactDuplicateField>(error, 'duplicateFields');
